var AWSCognito = require("amazon-cognito-identity-js");

import { cognito_register } from "./cognito.js";
import { cognito_login } from "./cognito.js";
import { cognito_forgot_password_confirm, cognito_user_data } from "./cognito";
import { cognito_forgot_password } from "./cognito";
import { cognito_session } from "./cognito.js";
import { cognito_confirm_registration } from "./cognito";
import { get_error_message } from "./messages";

// Main auth class that keep all informations about the user
export class Auth {
  // Initialize class with a link to a config file with  in a format
  // {
  //   user_pool_id: "eu-central-1_X4WezI4e6",
  //   client_id: "7vteedapb0bmkneu3hvgh01gh0",
  // }
  constructor(config) {
    this.config = config;
    this.cognito_user = null;
    this.session = null;
  }

  get_cognito_user(username) {
    var user_data = {
      Username: username,
      Pool: this.user_pool
    };
    var cognito_user = new AWSCognito.CognitoUser(user_data);
    return cognito_user;
  }

  // return currently authenticated user
  async get_current_user() {
    var current_user = this.user_pool.getCurrentUser();

    try {
      this.session = await cognito_session(current_user);
      console.log("SESSION:", this.session);
    } catch (e) {
      console.log("Fail to get a session");
    }
    this.cognito_user = current_user;
    return current_user;
  }

  // return True if user is authenticated false otherwise
  get is_authenticated() {
    if (this.session) {
      return true;
    } else {
      return false;
    }
  }

  // Get user data as an object
  async get_user_data() {
    var current_user = await this.get_current_user();
    // user data keeped as an object not a list so it's easier to
    // navigate through different elements
    var data = {};

    try {
      var result = await cognito_user_data(current_user);
      result.forEach(function(user_item) {
        data[user_item.Name] = user_item.Value;
      });
    } catch (e) {
      console.log("Failed to get user data:", e);
    }
    return data;
  }

  // Return AWS Cognito user pool
  get user_pool() {
    var poolData = {
      UserPoolId: this.config.user_pool_id,
      ClientId: this.config.client_id
    };
    return new AWSCognito.CognitoUserPool(poolData);
  }

  // Register a new user in AWS Cognito user pool
  // Provide username, password and attributes_list
  // Attributes list should be provided as array of objects:
  // {
  //   Name: "attribute_name",
  //   Value: "attribute_value"
  // }
  // List of attributes are configured in AWS Cognito
  async register(
    username,
    password,
    attributes_list,
    success_callback,
    failure_callback
  ) {
    var aws_attribute_list = [];
    attributes_list.forEach(function(attribute) {
      var cognito_user_attribute = new AWSCognito.CognitoUserAttribute(
        attribute
      );
      aws_attribute_list.push(cognito_user_attribute);
    });

    try {
      var result = await cognito_register(
        this.user_pool,
        username,
        password,
        aws_attribute_list
      );
      if (success_callback) {
        success_callback(result);
      }
    } catch (e) {
      if (failure_callback) {
        failure_callback(get_error_message(e));
      } else {
        console.log("No failure callback");
      }
    }
  }

  // confirm registration
  async confirm_registration(
    username,
    verification_code,
    success_callback,
    failure_callback
  ) {
    this.cognito_user = this.get_cognito_user(username);
    try {
      var result = await cognito_confirm_registration(
        this.cognito_user,
        verification_code
      );
      console.log("RESULT CONFIRM", result);
      if (success_callback) {
        success_callback(result);
      }
    } catch (e) {
      if (failure_callback) {
        failure_callback(get_error_message(e));
      }
    }
  }

  // Authenticate user in AWS Cognito using username and password
  async authenticate(username, password, success_callback, failure_callback) {
    var authentication_data = {
      Username: username,
      Password: password
    };
    var authentication_details = new AWSCognito.AuthenticationDetails(
      authentication_data
    );

    var cognito_user = this.get_cognito_user(username);
    this.cognito_user = cognito_user;

    try {
      var result = await cognito_login(
        this.cognito_user,
        authentication_details
      );

      if (success_callback) {
        success_callback(result);
      }
    } catch (e) {
      if (failure_callback) {
        failure_callback(get_error_message(e));
      }
    }
  }

  //forgot password
  async forgot_password(username, success_callback, failure_callback) {
    this.cognito_user = this.get_cognito_user(username);
    try {
      var result = await cognito_forgot_password(this.cognito_user);
      if (success_callback) {
        success_callback(result);
      }
    } catch (e) {
      if (failure_callback) {
        failure_callback(get_error_message(e));
      }
    }
  }

  //password confirm
  async confirm_password(
    username,
    verification_code,
    password,
    success_callback,
    failure_callback
  ) {
    this.cognito_user = this.get_cognito_user(username);
    try {
      var result = await cognito_forgot_password_confirm(
        this.cognito_user,
        verification_code,
        password
      );
      if (success_callback) {
        success_callback(result);
      }
    } catch (e) {
      if (failure_callback) {
        failure_callback(get_error_message(e));
      }
    }
  }
}
